export const REMOVE_SAVED_ITEM_REQUEST = 'REMOVE_SAVED_ITEM_REQUEST';
export const ATC_REMOVE_SAVED_ITEM_REQUEST = 'ATC_REMOVE_SAVED_ITEM_REQUEST';
